import React, { useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import SecondaryButton from "../Generic/SecondaryButton";
import EmbedDocumentationPage from "../../Pages/EmbedDocumentationPage/EmbedDocumentationPage";
import { showSuccessNotification, showGenericError } from "../../helper/Notifications";

const DownloadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M5.83333 8.33333L10 12.5M10 12.5L14.1667 8.33333M10 12.5V2.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EmbedDocumentationPageModal = ({ setShowDocumentationModal }) => {
  const [exportLoading, setExportLoading] = useState(false);

  const handleExport = async () => {
    try {
      setExportLoading(true);
      const pdfUrl = "https://emotii.s3.eu-west-1.amazonaws.com/static_files/WebsiteTranslation_Embed_API_Documentation_v1.pdf";
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "WebsiteTranslation_Embed_API_Documentation_v1.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      setExportLoading(false);
      showSuccessNotification("Documentation exported successfully");
    } catch (error) {
      setExportLoading(false);
      showGenericError();
    }
  };

  return (
    <FullscreenContainer>
      <Line>
        <HeadWrapper>
          <h1>Website Plugin</h1>
        </HeadWrapper>
        <ButtonGroup>
          <SecondaryButton
            icon={<DownloadIcon />}
            text="Export"
            onClick={handleExport}
            variant="neutral"
            loading={exportLoading}
          />
          <SecondaryButton
            text="Close"
            onClick={() => setShowDocumentationModal(false)}
            variant="neutral"
          />
        </ButtonGroup>
      </Line>
      <EmbedDocumentationPage />
    </FullscreenContainer>
  );
};

export default EmbedDocumentationPageModal;

const FullscreenContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 100;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  h1 {
    color: ${lightThemeColors.darkColor};
    font-size: 30px;
    font-weight: 600;
    line-height: 37.5px;
  }
  p {
    color: ${lightThemeColors.darkColorFaded30};
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
`;

const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  width: 100%;
  border-bottom: 1px solid #e5e7eb;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
